import * as Sentry from "@sentry/astro";

const ISLAND_FAILURE_REPORT_KEY = "frontflip:astro-island-failure-report";
const ISLAND_RECOVERY_EVENT_NAME = "frontflip:astro-island-recovery";

const captureIslandFailure = (report) => {
	if (!report || report.version !== 1) {
		return;
	}

	const error = new Error("Astro island module failed to load");
	error.name = "AstroIslandModuleLoadError";
	Sentry.captureException(error, {
		fingerprint: ["astro-island-module-load-failure"],
		tags: {
			component: "astro-island",
			recovery: report.recovery,
			online: String(report.online),
		},
		extra: {
			componentUrl: report.componentUrl,
			errorName: report.errorName,
			errorMessage: report.errorMessage,
			occurredAt: report.occurredAt,
			path: report.path,
		},
	});
};

const removePendingIslandFailure = () => {
	try {
		window.sessionStorage.removeItem(ISLAND_FAILURE_REPORT_KEY);
	} catch {
		// The recovery script already avoids reloading when sessionStorage is unavailable.
	}
};

Sentry.init({
	dsn: import.meta.env.PUBLIC_SENTRY_DSN,
	environment: process.env.NODE_ENV,
	// release: process.env.FRONTFLIP_COMMIT_SHA,

	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	debug: false,

	integrations: [Sentry.browserTracingIntegration()],

	// Define how likely traces are sampled. Adjust this value in production,
	// or use tracesSampler for greater control.
	tracesSampleRate: 0.05, // 1.0
	replaysSessionSampleRate: 0.05,
});

try {
	const pendingReport = window.sessionStorage.getItem(ISLAND_FAILURE_REPORT_KEY);
	if (pendingReport != null) {
		captureIslandFailure(JSON.parse(pendingReport));
		removePendingIslandFailure();
	}
} catch {
	removePendingIslandFailure();
}

window.addEventListener(ISLAND_RECOVERY_EVENT_NAME, (event) => {
	const { report, willReload } = event.detail ?? {};
	if (willReload) {
		return;
	}

	captureIslandFailure(report);
	removePendingIslandFailure();
});
